import { oneIdentifier } from '~shared/config/hostname';

export type TenantId = 'familux';

export const isFamiluxTenant = (id: string = oneIdentifier): boolean =>
  id.endsWith('-familux');

export const getActiveTenant = (
  id: string = oneIdentifier,
): TenantId | null => {
  if (isFamiluxTenant(id)) return 'familux';
  return null;
};
